/**
 * Allow-list counterpart to `shouldNotShowOnCurrentPage`. When a dialogue
 * provides `includeSlugs`, it should only show on pages whose path matches one
 * of them. With no `includeSlugs` the dialogue is unrestricted (subject to its
 * exclude list).
 */
export const shouldShowOnCurrentPage = ({
  popupIncludeSlugs,
  pathname,
}: {
  popupIncludeSlugs?: (string | RegExp)[];
  pathname: string;
}) => {
  if (!popupIncludeSlugs?.length) {
    return true;
  }

  return popupIncludeSlugs.some((slug) => !!pathname.match(slug));
};
